import { useEffect, useState } from "react";
import { read } from "../../net/rally.ts";
import type { Stacking } from "../panel/panels.tsx";
import type { AppChoice } from "./app-attachments.tsx";
import { appCard, type ListedApp } from "./app-resource.tsx";

export function useAppsInConversation(conversation: string): AppChoice[] {
  const [apps, setApps] = useState<AppChoice[]>([]);
  useEffect(() => {
    void read<ListedApp[]>("apps.in", { conversation })
      .then(setApps)
      .catch(() => setApps([]));
  }, [conversation]);
  return apps;
}

export function useAppTarget(conversation: string, placement: string | null, stack: Stacking): void {
  useEffect(() => {
    if (!placement) return;
    let live = true;
    void read<ListedApp[]>("apps.in", { conversation })
      .then((listed) => {
        const found = listed.find((one) => one.placement === placement);
        if (live && found) stack.open(appCard(found));
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [placement, conversation, stack.open]);
}
